var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-button d-flex"},[_c('b-button',{staticClass:"w-100 d-flex align-items-center justify-content-center",class:{
      disabled: _vm.isDisable,
      round: _vm.isRound,
      'padding-icon': (_vm.iconLeft || _vm.iconRight) && _vm.styleInIcon,
    },style:(_vm.styleInButton),attrs:{"variant":_vm.variant,"size":_vm.buttonSize},on:{"click":function($event){return _vm.clickButton()}}},[(_vm.iconLeft)?_c('feather-icon',{style:(_vm.styleInIcon),attrs:{"icon":_vm.iconLeft}}):_vm._e(),(_vm.$scopedSlots.default)?_c('span',{class:{
        'atom-button--margin-left': _vm.iconLeft,
        'atom-button--margin-right': _vm.iconRight,
      }},[_vm._t("default")],2):_vm._e(),(_vm.iconRight)?_c('feather-icon',{style:(_vm.styleInIcon),attrs:{"icon":_vm.iconRight}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }